// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Divider INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var UUDivider = function UUDivider(props) {
  var id = props.id,
    className = props.className,
    style = props.style;
  var uiDividerClass = 'border-0 border-b-1/16 border-dark-fill-blue';
  var dividerClass = classNames(uiDividerClass, className, style);
  return /*#__PURE__*/React.createElement("hr", {
    id: id,
    className: dividerClass,
    "data-testid": id
  });
};
UUDivider.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.string
};
UUDivider.defaultProps = {
  className: '',
  id: '',
  style: ''
};
export default UUDivider;